import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

const checkRole = (user, roles) => {
  if (!user || !user.role) return false;
  return roles.includes(user.role);
};

function EditRacePage() {
  const { raceId } = useParams();
  const navigate = useNavigate();
  const [date, setDate] = useState('');
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const checkUserRoleAndFetchRace = async () => {
      try {
        const userResponse = await axios.get('/api/users/status');
        const currentUser = userResponse.data.user;

        if (!checkRole(currentUser, ['admin', 'director'])) {
          setMessage('Unauthorized: You do not have permission to edit races.');
          navigate('/races'); // Redirect to race list
          return;
        }

        const raceResponse = await axios.get(`/api/races/${raceId}`);
        const race = raceResponse.data;
        setDate(race.date.split('T')[0]); // Format date for input
        setName(race.name);
        setCity(race.city);
        setState(race.state);
      } catch (error) {
        setMessage('Error fetching race or checking role: ' + (error.response?.data || error.message));
        navigate('/races'); // Redirect on error
      }
    };
    checkUserRoleAndFetchRace();
  }, [raceId, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`/api/races/${raceId}`, { date, name, city, state });
      setMessage(response.data.message || 'Race updated successfully!');
      navigate('/races'); // Redirect to race list after update
    } catch (error) {
      console.error('Error updating race:', error);
      setMessage(error.response?.data || 'Error updating race.');
    }
  };

  return (
    <div>
      <h2>Edit Race</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Date:</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Name:</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>City:</label>
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            required
          />
        </div>
        <div>
          <label>State:</label>
          <input
            type="text"
            value={state}
            onChange={(e) => setState(e.target.value)}
            required
          />
        </div>
        <button type="submit">Update Race</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}

export default EditRacePage;
